(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48521,61971,93812],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 61971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* eslint-disable react/destructuring-assignment */ 




var ScrollAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(45003), __webpack_require__.e(68741)]).then(__webpack_require__.bind(__webpack_require__, 68741));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68741)
            ];
        }
    }
});
var Reveal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 8365).then(__webpack_require__.t.bind(__webpack_require__, 8365, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8365)
            ];
        }
    }
});
var Fade = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19470).then(__webpack_require__.t.bind(__webpack_require__, 19470, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19470)
            ];
        }
    }
});
var CSSAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 90959).then(__webpack_require__.bind(__webpack_require__, 90959)).then(function(module) {
        return module.CSSAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90959)
            ];
        }
    }
});
var ImageZoom = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 16626).then(__webpack_require__.bind(__webpack_require__, 16626));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16626)
            ];
        }
    }
});
var Gsap = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94744).then(__webpack_require__.bind(__webpack_require__, 94744)).then(function(module) {
        return module.Gsap;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94744)
            ];
        }
    }
});
var ParallaxWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(11897)]).then(__webpack_require__.bind(__webpack_require__, 11897));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11897)
            ];
        }
    }
});
var ExpandWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68376).then(__webpack_require__.bind(__webpack_require__, 68376)).then(function(module) {
        return module.ExpandWrapper;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68376)
            ];
        }
    }
});
var CustomAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52612).then(__webpack_require__.bind(__webpack_require__, 52612)).then(function(module) {
        return module.CustomAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52612)
            ];
        }
    }
});
var JSONAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25845).then(__webpack_require__.bind(__webpack_require__, 25845)).then(function(module) {
        return module.JSONAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25845)
            ];
        }
    }
});
var Bounce = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94803).then(__webpack_require__.t.bind(__webpack_require__, 94803, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94803)
            ];
        }
    }
});
var CounterAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(78162)]).then(__webpack_require__.bind(__webpack_require__, 78162));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78162)
            ];
        }
    }
});
var ZoomOut = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(30730)]).then(__webpack_require__.bind(__webpack_require__, 30730));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30730)
            ];
        }
    }
});
var Animated = function(props) {
    switch(props.type){
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isReveal */ .BK.isReveal:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reveal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isFade */ .BK.isFade:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fade, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCustom */ .BK.isCustom:
            {
                if (Object.keys(props).length === 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isJSON */ .BK.isJSON:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JSONAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isParallaxSpring */ .BK.isParallaxSpring:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParallaxWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageZoom, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.gsap */ .BK.gsap:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gsap, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.expandByHeight */ .BK.expandByHeight:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpandWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCSS */ .BK.isCSS:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CSSAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.bounce */ .BK.bounce:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bounce, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    })
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.counter */ .BK.counter:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CounterAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.zoomOut */ .BK.zoomOut:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ZoomOut, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Animated);


/***/ }),

/***/ 96366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_CaseProcess; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./UI/containers/Animated/index.jsx
var Animated = __webpack_require__(61971);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/Media/index.jsx + 2 modules
var Media = __webpack_require__(34190);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./UI/sections/CaseProcess/utils/animations.js



var STEP_TITLE_ANIMATION = (0,_define_property/* default */.Z)({}, constants/* CASE_STUDIES.mobileBudgetingApp */.qU.mobileBudgetingApp, {
    secondSectionView: {
        type: "counter"
    }
});
var _obj;
var CARD_ANIMATION = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.mobileBudgetingApp */.qU.mobileBudgetingApp, {
    secondSectionView: (0,_object_spread/* default */.Z)({}, constants/* BOUNCE_ANIMATION_PROPS */.QH),
    thirdSectionView: (0,_object_spread/* default */.Z)({}, constants/* BOUNCE_ANIMATION_PROPS */.QH),
    fourthSectionView: (0,_object_spread/* default */.Z)({}, constants/* BOUNCE_ANIMATION_PROPS */.QH)
}), (0,_define_property/* default */.Z)(_obj, "why-us", {
    firstSectionView: (0,_object_spread/* default */.Z)({}, constants/* BOUNCE_ANIMATION_PROPS */.QH)
}), (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.kitchenEquipment */.qU.kitchenEquipment, {
    firstSectionView: (0,_object_spread/* default */.Z)({}, constants/* BOUNCE_ANIMATION_PROPS */.QH)
}), _obj);

;// CONCATENATED MODULE: ./UI/sections/CaseProcess/utils/useSectionProps.js




/* harmony default export */ function useSectionProps(param) {
    var data = param.data, type = param.type;
    var ref, ref1;
    var title = data.title, subtitle = data.subtitle, description = data.description, imagesData = data.images, contentModules = data.contentModules, view = data.view;
    var images = imagesData === null || imagesData === void 0 ? void 0 : imagesData.map(function(module) {
        return (0,helper/* getImage */.gJ)(module);
    });
    var steps = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(param) {
        var fields = param.fields;
        var ref, ref1;
        var stepTitle = fields.title, stepSubtitle = fields.subtitle, contentList = fields.contentList, text = fields.text, imageAsBackground = fields.imageAsBackground, svgWithWrapper = fields.svgWithWrapper;
        var imageBundles = (ref = fields.imagesBundles) === null || ref === void 0 ? void 0 : ref.map(function(bundle) {
            return (0,helper/* getFileUrl */.qm)(bundle);
        });
        var image = !imageAsBackground ? (ref1 = fields.images) === null || ref1 === void 0 ? void 0 : ref1[0] : null;
        var backgroundImageUrl = imageAsBackground ? (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(fields, "images[0]", "")), {
            fm: "png"
        }) : null;
        var style = backgroundImageUrl ? {
            backgroundImage: "url(".concat(backgroundImageUrl, ")")
        } : {};
        return {
            imageBundles: imageBundles,
            stepSubtitle: stepSubtitle,
            text: text,
            stepTitle: stepTitle,
            icon: contentList === null || contentList === void 0 ? void 0 : contentList[0],
            image: image,
            style: style,
            svgWithWrapper: svgWithWrapper
        };
    });
    var isTitleAnimated = (ref = STEP_TITLE_ANIMATION[type]) === null || ref === void 0 ? void 0 : ref[view];
    var isCardAnimated = ((ref1 = CARD_ANIMATION[type]) === null || ref1 === void 0 ? void 0 : ref1[view]) || constants/* REVEAL_ANIMATION_PROPS */.kt;
    var backgroundUrl = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(data, "background", {})), {
        fm: "webp"
    });
    var style = backgroundUrl ? {
        backgroundImage: "url(".concat(backgroundUrl, ")")
    } : {};
    return {
        type: type,
        style: style,
        title: title,
        subtitle: subtitle,
        description: description,
        images: images,
        steps: steps,
        view: view,
        isTitleAnimated: isTitleAnimated,
        isCardAnimated: isCardAnimated
    };
};

// EXTERNAL MODULE: ./UI/sections/CaseProcess/styles.module.scss
var styles_module = __webpack_require__(1705);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/CaseProcess/index.jsx















var CaseProcess = function(_param) {
    var rightSide = _param.rightSide, props = (0,_object_without_properties/* default */.Z)(_param, [
        "rightSide"
    ]);
    var ref = useSectionProps(props), type = ref.type, view = ref.view, style = ref.style, title = ref.title, subtitle = ref.subtitle, description = ref.description, images = ref.images, steps = ref.steps, isTitleAnimated = ref.isTitleAnimated, isCardAnimated = ref.isCardAnimated;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default())[view], (styles_module_default())[type], (styles_module_default()).section),
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                subtitle: subtitle,
                description: description,
                className: (styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).stepsContainer,
                        children: steps === null || steps === void 0 ? void 0 : steps.map(function(param, index) {
                            var stepTitle = param.stepTitle, text = param.text, stepSubtitle = param.stepSubtitle, imageBundles = param.imageBundles, icon = param.icon, image = param.image, stepStyle = param.style, svgWithWrapper = param.svgWithWrapper;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Animated["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isCardAnimated), {
                                delay: 50 + (index + 1) * 50,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((styles_module_default()).step, (styles_module_default())["step-".concat(index + 1)]),
                                    style: stepStyle,
                                    children: [
                                        image && (svgWithWrapper ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).imageWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                                                asset: image,
                                                className: (styles_module_default()).stepImage
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                                            asset: image,
                                            className: (styles_module_default()).stepImage
                                        })),
                                        icon && (svgWithWrapper ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).imageWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                                type: icon,
                                                className: (styles_module_default()).stepIcon
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                            type: icon,
                                            className: (styles_module_default()).stepIcon
                                        })),
                                        stepSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                            variant: "span",
                                            className: (styles_module_default()).stepNumber,
                                            children: stepSubtitle
                                        }),
                                        stepTitle && (isTitleAnimated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isTitleAnimated), {
                                            className: (styles_module_default()).stepTitle,
                                            children: stepTitle
                                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                            variant: "h3",
                                            className: (styles_module_default()).stepTitle,
                                            children: stepTitle
                                        })),
                                        text && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                            document: text
                                        }),
                                        imageBundles === null || imageBundles === void 0 ? void 0 : imageBundles.map(function(url, indexBundleImage) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                                trasparent: true,
                                                className: classnames_default()((styles_module_default()).bundleImage, (styles_module_default())["bundleImage-".concat(indexBundleImage + 1)]),
                                                src: url,
                                                alt: stepTitle
                                            }, "images-bundles/".concat(url));
                                        })
                                    ]
                                })
                            }), index);
                        })
                    }),
                    !!(images === null || images === void 0 ? void 0 : images.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).imagesContainer,
                        children: images === null || images === void 0 ? void 0 : images.map(function(image, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                transparent: true,
                                priority: true,
                                className: classnames_default()((styles_module_default()).image, (styles_module_default())["image-".concat(index + 1)]),
                                alt: image.alt,
                                src: image.url
                            });
                        })
                    })
                ]
            }),
            !!rightSide && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).rightSideWrapper,
                children: rightSide
            })
        ]
    });
};
CaseProcess.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string
};
/* harmony default export */ var sections_CaseProcess = (CaseProcess);


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 1705:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__2Hr_Q","container":"styles_container__BaiNR","stepsContainer":"styles_stepsContainer__sFq2_","step":"styles_step___sBNc","stepNumber":"styles_stepNumber__btquZ","stepTitle":"styles_stepTitle__N6H8o","image":"styles_image__xNgPF","writer-chrome-extension":"styles_writer-chrome-extension__pC01q","secondSectionView":"styles_secondSectionView__p7OMJ","dindon":"styles_dindon__pMRO9","titleStyle":"styles_titleStyle__07IfP","bundleImage":"styles_bundleImage__5lrvj","bundleImage-1":"styles_bundleImage-1__auOiG","bundleImage-2":"styles_bundleImage-2__nUZVp","step-3":"styles_step-3__oP_Y9","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__CHZb5","firstSectionView":"styles_firstSectionView__8f3yI","stepIcon":"styles_stepIcon__gJSZM","thirdSectionView":"styles_thirdSectionView__CwiDD","step-6":"styles_step-6__BCISe","cedar-valley-farms":"styles_cedar-valley-farms__HRExk","stepImage":"styles_stepImage__kDxgB","mobile-budgeting-app":"styles_mobile-budgeting-app__HjIMV","step-1":"styles_step-1__AbLfS","step-2":"styles_step-2__nPT_v","step-5":"styles_step-5__esFYA","fourthSectionView":"styles_fourthSectionView__5y9Jt","step-7":"styles_step-7__niwv7","forex-trading-platform":"styles_forex-trading-platform__D5PhJ","why-us":"styles_why-us__PwX2M","crowdfunding-platform":"styles_crowdfunding-platform__Zd_dt","cctv-footage-analytics":"styles_cctv-footage-analytics__gwkCv","web-chat-for-mediums":"styles_web-chat-for-mediums__PmPO_","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__DViO6","mobile-music-app":"styles_mobile-music-app__xe7m8","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__XwJaZ","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__nw4y_","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__9GgQn","fifthSectionView":"styles_fifthSectionView__WY6_C","imagesContainer":"styles_imagesContainer__jJXeF","image-1":"styles_image-1__QR60T","image-2":"styles_image-2__xs8x8","custom-payment-gateway":"styles_custom-payment-gateway__ibPJ6","mobile-bank-application":"styles_mobile-bank-application__Ug8Xl","company":"styles_company__0R0fr","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__pGh3z","ai-based-travel-planner":"styles_ai-based-travel-planner__3mul8","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__UDqZC","image-3":"styles_image-3__fSX2t","writer-framework-platform":"styles_writer-framework-platform__bBmMN","step-4":"styles_step-4__SLIny","computer-vision-for-aras":"styles_computer-vision-for-aras__IikOl","imageWrapper":"styles_imageWrapper__cjE0c","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__emsAQ","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__Fc11o","pen-tests-ai":"styles_pen-tests-ai__w9Ixq","web-logistics-platform":"styles_web-logistics-platform__MNjr_","llm-legal-document-summarization":"styles_llm-legal-document-summarization__J2o_y","ai-feedback-analysis":"styles_ai-feedback-analysis__HmBtr","ai-for-edtech":"styles_ai-for-edtech__t3UbX","ai-reporting-assistant":"styles_ai-reporting-assistant__ibotw","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__BvEyw","feedback-insight-engine":"styles_feedback-insight-engine__JuyVE","predictive-ai-for-marketing":"styles_predictive-ai-for-marketing__BQGJR","ai-agent-for-pre-screening":"styles_ai-agent-for-pre-screening__fs8M3","ai-concierge-for-hotel-network":"styles_ai-concierge-for-hotel-network__DiB4I","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__fHPwv","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__Gnx7N","services":"styles_services__9mv52","rightSideWrapper":"styles_rightSideWrapper___mmr9","newhomepage":"styles_newhomepage__P3mCQ","ai-warehouse-agent":"styles_ai-warehouse-agent__KgfPY","sixthSectionView":"styles_sixthSectionView__etUyI","rag-contract-intelligence-platform":"styles_rag-contract-intelligence-platform__9Hd9g","claude-sonnet-leasing-operations-platform":"styles_claude-sonnet-leasing-operations-platform___Sf6K","seventhSectionView":"styles_seventhSectionView__CCO8K","influx":"styles_influx__JkOaM","futurepay":"styles_futurepay__QncVK","contentWrapper":"styles_contentWrapper__Osg8Q","commod":"styles_commod__J59db","blinking":"styles_blinking__kVyw2","swing":"styles_swing__2dMjn","animateborder":"styles_animateborder__X8HeZ","animateborder-overlay":"styles_animateborder-overlay__0xgA_","animatecircle":"styles_animatecircle__FFfQG","animatedot":"styles_animatedot__1B_4j","animStar":"styles_animStar__CILGP","hideText":"styles_hideText__EeDoa","spin":"styles_spin__dxJn1","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__ZzHmV","outOfTransparencyMobile":"styles_outOfTransparencyMobile__xZPrS","appearance":"styles_appearance__jGMkT","appearanceFromBelow":"styles_appearanceFromBelow___KDYP","flicker":"styles_flicker__VThwh","vibrate1":"styles_vibrate1__Y1jBS","rocket":"styles_rocket__M9vO2","burgerItem1":"styles_burgerItem1__0StaK","burgerItem2":"styles_burgerItem2__9LRuE","burgerItem3":"styles_burgerItem3__ihz1R","burgerItem1Reverse":"styles_burgerItem1Reverse__eNhp9","burgerItem2Reverse":"styles_burgerItem2Reverse__m6DoM","burgerItem3Reverse":"styles_burgerItem3Reverse__SfmhN","arrow-down":"styles_arrow-down__RyZvU","image-scroll":"styles_image-scroll__rwBBo","image-scroll-reverse":"styles_image-scroll-reverse__gRBrz","stickerbox-pointer-move":"styles_stickerbox-pointer-move__9Wi8a","hide-image":"styles_hide-image__JfSf1","stickerbox-pointer-second":"styles_stickerbox-pointer-second__4VTq3","stickerbox-pointer-third":"styles_stickerbox-pointer-third__3th4Z","cedar-bounce":"styles_cedar-bounce__7hta3"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);